import React from 'react';
import { 
    Card, 
    CardContent, 
    CardHeader,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Typography,
    Chip,
    Box
} from '@mui/material';
import { 
    Games,
    Schedule,
    Person,
    AccessTime
} from '@mui/icons-material';

interface ActivityItem {
    id: string;
    type: 'game' | 'schedule' | 'user';
    title: string;
    subtitle: string;
    timestamp: string;
    status?: 'active' | 'completed' | 'pending';
}

const RecentActivity: React.FC = () => {
    const mockActivities: ActivityItem[] = [
        {
            id: '1',
            type: 'game',
            title: 'New Game Created',
            subtitle: 'Hollywood Legends - 50 questions added',
            timestamp: '2 hours ago',
            status: 'active'
        },
        {
            id: '2',
            type: 'schedule',
            title: 'Game Scheduled',
            subtitle: 'Movies of the 90s scheduled for tomorrow',
            timestamp: '4 hours ago',
            status: 'pending'
        },
        {
            id: '3',
            type: 'user',
            title: 'Player Activity',
            subtitle: '127 players completed games today',
            timestamp: '6 hours ago',
            status: 'completed'
        },
        {
            id: '4',
            type: 'game',
            title: 'Game Updated',
            subtitle: 'Sports Legends - 5 questions modified',
            timestamp: '1 day ago',
            status: 'completed'
        }
    ];

    const getIcon = (type: string) => {
        switch (type) {
            case 'game': return <Games />;
            case 'schedule': return <Schedule />;
            case 'user': return <Person />;
            default: return <AccessTime />;
        }
    };

    const getStatusColor = (status?: string) => {
        switch (status) {
            case 'active': return 'success';
            case 'pending': return 'warning';
            case 'completed': return 'default';
            default: return 'default';
        }
    };

    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader 
                title="Recent Activity" 
                titleTypographyProps={{ variant: 'h6' }}
            />
            <CardContent sx={{ pt: 0 }}>
                <List sx={{ width: '100%' }}>
                    {mockActivities.map((activity, index) => (
                        <ListItem 
                            key={activity.id}
                            sx={{ 
                                px: 0,
                                borderBottom: index < mockActivities.length - 1 ? '1px solid #f0f0f0' : 'none'
                            }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                {getIcon(activity.type)}
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Typography variant="body2" component="span">
                                            {activity.title}
                                        </Typography>
                                        {activity.status && (
                                            <Chip 
                                                label={activity.status}
                                                size="small"
                                                color={getStatusColor(activity.status) as any}
                                                sx={{ height: 20, fontSize: '0.7rem' }}
                                            />
                                        )}
                                    </Box>
                                }
                                secondary={
                                    <Box>
                                        <Typography variant="caption" color="text.secondary">
                                            {activity.subtitle}
                                        </Typography>
                                        <br />
                                        <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                            {activity.timestamp}
                                        </Typography>
                                    </Box>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Card>
    );
};

export default RecentActivity;